import request from '@/utils/request'
export function queryModel(data) {//礼品卡,商品列查询
  return request({
	url:`/serialnumber/queryModel?model=${data.model}`,
    method: 'get',
	// data:new URLSearchParams(data).toString()
  })
}
export function validateSn(data) {
  return request({
	url:`/serialnumber/validateSn?sn=${data.sn}`,
    method: 'get',
	// data:new URLSearchParams(data).toString()
  })
}
export function serialnumberuse(data) {
  return request({
	url:`/serialnumber/use`,
    method: 'post',
	data:data
  })
}
export function querytemplate(data, config = {}) {//礼品卡,商品列查询
  return request({
	  url:`/serialnumber/template`,
	  method: 'post',
	  data:data,
	   ...config
  })
}
